var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCardIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7191 5.14645L2.42572 23.9998C2.19288 24.403 2.06967 24.8602 2.06837 25.3258C2.06707 25.7914 2.18771 26.2493 2.41829 26.6538C2.64887 27.0583 2.98135 27.3955 3.38266 27.6316C3.78397 27.8677 4.24012 27.9947 4.70572 27.9998H27.2924C27.758 27.9947 28.2141 27.8677 28.6154 27.6316C29.0168 27.3955 29.3492 27.0583 29.5798 26.6538C29.8104 26.2493 29.931 25.7914 29.9297 25.3258C29.9284 24.8602 29.8052 24.403 29.5724 23.9998L18.2791 5.14645C18.0414 4.75459 17.7067 4.43061 17.3073 4.20576C16.9079 3.98092 16.4574 3.86279 15.9991 3.86279C15.5407 3.86279 15.0902 3.98092 14.6908 4.20576C14.2914 4.43061 13.9567 4.75459 13.7191 5.14645Z",
    fill: "url(#paint0_linear_1433_31088)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12V17.3333",
    stroke: "#ED4141",
    strokeWidth: 1.86667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.6665H16.0133",
    stroke: "#ED4141",
    strokeWidth: 1.86667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_31088",
    x1: 10.6673,
    y1: 7.33317,
    x2: 27.334,
    y2: 29.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA217"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCardIcon4);
export default __webpack_public_path__ + "static/media/mail_card_icon4.4275d6e4a85ad961dd17a3b186dacd87.svg";
export { ForwardRef as ReactComponent };